(() => {
 if(window.AlcBasketSync)return;
 const money=v=>new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format((Number(v)||0)/100);
 const root=()=>window.Shopify?.routes?.root||'/';
 function render(c){if(!c||typeof c.item_count!=='number')return;
  document.querySelectorAll('[data-alc-cart-count]').forEach(el=>el.textContent=String(c.item_count));
  document.querySelectorAll('[data-alc-cart-total]').forEach(el=>el.textContent=money(c.total_price));
 }
 let pending=null;
 function refresh(){if(pending)return pending;
  pending=fetch(root()+'cart.js',{credentials:'same-origin',cache:'no-store'}).then(r=>r.ok?r.json():null).then(render).catch(()=>{}).finally(()=>{pending=null});return pending;
 }
 window.AlcBasketSync={render,refresh};
 const nativeFetch=window.fetch.bind(window);
 window.fetch=(req,opt)=>{
  const result=nativeFetch(req,opt);
  try{const url=String(typeof req==='string'?req:req?.url||'');
   if(/\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url))result.then(r=>{if(r.ok)setTimeout(refresh,120)}).catch(()=>{});
  }catch(e){}return result;
 };
 function start(){refresh();if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){subscribe(PUB_SUB_EVENTS.cartUpdate,refresh);}
  document.addEventListener('change',e=>{if(e.target.closest('cart-items,cart-drawer,form[action*="/cart"]'))setTimeout(refresh,450)},true);
  document.addEventListener('shopify:section:load',refresh);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
 window.addEventListener('pageshow',refresh);
 window.addEventListener('focus',refresh);
})();